import { render, staticRenderFns } from "./sch_list.vue?vue&type=template&id=c5c24130&scoped=true"
import script from "./sch_list.vue?vue&type=script&lang=js"
export * from "./sch_list.vue?vue&type=script&lang=js"
import style0 from "./sch_list.vue?vue&type=style&index=0&id=c5c24130&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c24130",
  null
  
)

export default component.exports